import React from 'react';
import HomeDropdown from '../components/HomeDropdown';
import NavLinks from '../components/NavLinks';

const HeaderNav = ({ 
  currentPage,
  className = ''
}) => {
  return (
    <nav className={`nav-main ${className}`} role="navigation" aria-label="Main navigation">
      <ul className="nav-links-header">
        <HomeDropdown 
          currentPage={currentPage}
          variant="header"
          dropdownVisible={false}
          onToggleDropdown={() => {}}
          onItemClick={() => {}}
        />
        <NavLinks 
          currentPage={currentPage}
          variant="header"
        />
      </ul>
    </nav>
  );
};

export default HeaderNav;